/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairBoardingPassDocumentType } from '../../models/finnair-boarding-pass-document-type';

export interface GetBoardingPassLink$Params {
  orderId: string;
  flightId: string;
  travelerId: string;
  hash: string;
  type: FinnairBoardingPassDocumentType;
}

export function getBoardingPassLink(http: HttpClient, rootUrl: string, params: GetBoardingPassLink$Params, context?: HttpContext): Observable<DapiHttpResponse<void>> {
  const rb = new DapiRequestBuilder(rootUrl, getBoardingPassLink.PATH, 'get');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.path('flightId', params.flightId, {});
    rb.path('travelerId', params.travelerId, {});
    rb.query('hash', params.hash, {});
    rb.query('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
    }),
    catchErrorAsJson()
  );
}

getBoardingPassLink.PATH = '/api/v2/checkin/{orderId}/{flightId}/{travelerId}/get-boarding-pass';
